import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "notification-detail" }
const _hoisted_2 = { class: "notification-detail__search mb-2" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "notification-detail__search-icon"
}
const _hoisted_5 = {
  key: 0,
  class: "mb max-width-text"
}
const _hoisted_6 = {
  key: 1,
  class: "mb max-width-text"
}
const _hoisted_7 = { class: "mb-05" }
const _hoisted_8 = {
  class: "notification-detail-content",
  key: "content"
}
const _hoisted_9 = {
  class: "flex",
  key: "loader"
}
const _hoisted_10 = {
  class: "gray3--text",
  key: "no-result"
}
const _hoisted_11 = {
  class: "flex flex-wrap",
  key: "overview"
}
const _hoisted_12 = { class: "mr-1" }
const _hoisted_13 = { class: "mr-1" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "notification-detail__search-input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchString) = $event)),
        placeholder: _ctx.$t("MY_ENVIRONMENT.NOTIFICATION.EMAIL_SEARCH")
      }, null, 8, _hoisted_3), [
        [_vModelText, _ctx.searchString]
      ]),
      (_ctx.searchString)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "notification-detail__search-clear",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchString = ""))
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "icons8-delete" }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      (!_ctx.searchString)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "icons8-search" }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isGerman)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.EMAIL_DESCRIPTION', [ _ctx.capitalize(_ctx.$t(`MY_ENVIRONMENT.NOTIFICATION.${_ctx.notificationType.toUpperCase()}`)) ])), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.EMAIL_DESCRIPTION', [ _ctx.$t(`MY_ENVIRONMENT.NOTIFICATION.${_ctx.notificationType.toUpperCase()}`).toLowerCase() ])), 1)),
    _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.ADDED_EMAIL_ADDRESSES')), 1),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                  return _createElementVNode("div", {
                    class: "notification-detail__skeleton flex-grow-1",
                    key: n
                  })
                }), 64))
              ]))
            : (_ctx.showNoResult)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.NO_EMAILS_ADDED')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (notification) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "email-block flex flex-align-center mb mr",
                      key: `${notification.email}-${notification.type}`
                    }, [
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "icons8-user-2 mr-025" }, null, -1)),
                      _createElementVNode("b", _hoisted_12, _toDisplayString(notification.name), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "icons8-language mr-025" }, null, -1)),
                      _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.$t(`MY_ENVIRONMENT.NOTIFICATION.LANGUAGE.${notification.language.toUpperCase()}`)), 1),
                      _createElementVNode("span", null, _toDisplayString(notification.email), 1),
                      (_ctx.hasPermission(_ctx.permissions.NotificationChange) && !_ctx.isLastInvoiceAddress)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: "icons8-pencil ml-05",
                            onClick: ($event: any) => (_ctx.showCrudEmailSheet(_ctx.actions.Update, notification))
                          }, null, 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission(_ctx.permissions.NotificationChange) && !_ctx.isLastInvoiceAddress)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 1,
                            class: "icons8-waste ml-05",
                            onClick: ($event: any) => (_ctx.showCrudEmailSheet(_ctx.actions.Delete, notification))
                          }, null, 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _: 1
    })
  ]))
}